/**
 * Langues livrées avec l'application (INTERNATIONAL.md §3).
 *
 * L'ordre fait foi : la première est la langue de rédaction, celle sur laquelle
 * se replient les contenus non traduits.
 */
export const SUPPORTED_LOCALES = ["fr", "en", "es", "de", "nl"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

/** Langue de repli lorsqu'une traduction manque. */
export const FALLBACK_LOCALE: Locale = "fr";

export function isSupportedLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
